import './Sidebar.css';

function Sidebar({ currentFolder, onFolderChange, collapsed, visible, onClose, emailCounts }) {
  const folders = [
    { id: 'inbox', label: 'Inbox', icon: 'fa-inbox' },
    { id: 'sent', label: 'Sent', icon: 'fa-paper-plane' }
  ];

  return (
    <>
      <div className={`sidebar-overlay ${visible ? 'visible' : ''}`} onClick={onClose}></div>
      <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${visible ? 'visible' : ''}`}>
        <nav className="sidebar-nav">
          {folders.map(folder => {
            const count = emailCounts?.[folder.id] || 0;
            return (
              <button
                key={folder.id}
                className={`nav-item ${currentFolder === folder.id ? 'active' : ''}`}
                onClick={() => onFolderChange(folder.id)}
              >
                <i className={`fas ${folder.icon}`}></i>
                <span>{folder.label}</span>
                {count > 0 && <span className="badge">{count}</span>}
              </button>
            );
          })}
        </nav>
        <div className="sidebar-footer">
          <div className="developer-info">
            <p>
              Developed by:{' '}
              <a href="mailto:masakanda@mail.itcpr.org">Md Abdus Sami Akanda</a>{' '}
              for <a href="https://itcpr.org">ITCPR</a>
            </p>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
